module.exports = __webpack_public_path__ + "static/media/4D.36b51a18.jpg";